import {
  Button,
  Col,
  Divider,
  Dropdown,
  Menu,
  message,
  PageHeader,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { ChevronDown } from "react-feather";

import axios from "axios";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CardBody } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import {
  EstimateApi,
  EstimatePdfOpenApi,
  ProjectMemberApi
} from "../../../../api";
import {
  changeEstimateAssignee,
  createBudgetItemFromEstimate,
  fetchEstimateRevisionData,
  resendEstimateMail,
} from "../../../../api/estimate.api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import handlePdfDownload from "../../../../utils/AwsFunctions/downloadFile";
import { getFormattedDate } from "../../../../utils/DateFunctions/dateFormatter";
import { poCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import TaxAmount from "./taxAmount";

const EstimateDetails = (props) => {
  const history = useNavigate();
  const scollToRef = useRef();

  const { estimate_id: estimateId } = useParams();
  const [details, setDetails] = useState(null);
  const [showRevisions, setShowRevisions] = useState(false);
  const [revisionData, setRevisionData] = useState(null);
  const [rowSelectionVisible, setRowSelectionVisible] = useState(false);
  const [organisationDetails, setOrganisationDetails] = useState(null);
  const [projectDetails, setProjectDetails] = useState(props.settings?.project);
  const [members, setMembers] = useState([]);
  const [assignedTo, setAssignedTo] = useState(null);

  const fetchMembers = (params = {}) => {
    axios.get(`${ProjectMemberApi}`, { params: { ...params } }).then((res) => {
      setMembers(res.data);
    });
  };

  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };
  const setReduxProject = (project) => {
    const { dispatch } = props;

    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: project,
      },
    });
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "projectSelected",
        value: true,
      },
    });
  };

  React.useEffect(() => {
    if (props.settings?.project?.id) {
      fetchMembers({ project: props.settings?.project?.id });
    }
    axios.get(`${EstimateApi}?id=${estimateId}`).then((response) => {
      if (Array.isArray(response.data?.results)) {
        const estimate = response.data?.results[0];
        setAssignedTo(estimate?.assigned_to?.id ?? null);
        setDetails(estimate);
        if (!props.settings?.project?.id) {
          setProjectDetails(estimate?.project);
          setReduxProject(estimate?.project);
          fetchMembers({ project: estimate?.project?.id });
        }
        if (response.data?.length > 0) {
          fetchEstimateRevisionData(estimate?.estimate_no).then((res) => {
            setRevisionData(res);
          });
        }
      } else {
        setDetails(response.data);
        setAssignedTo(response?.data?.assigned_to?.id ?? null);
      }
    });
    getOrganisationDetails();
  }, [estimateId]);

  useEffect(() => {}, [scollToRef]);

  const statusOptions = [
    { id: "1", value: "draft", label: "Draft" },
    {
      id: "2",
      value: "pricing_and_availability_check",
      label: "Pricing and Availability Check",
    },
    {
      id: "3",
      value: "availability_check",
      label: "Availability Check",
    },
    {
      id: "4",
      value: "quote_approval_pending",
      label: "Quote Approval pending",
    },
    {
      id: "5",
      value: "quotation_approved",
      label: "Quotation Approved - Initiate Delivery",
    },
    {
      id: "6",
      value: "order_lost",
      label: "Order Lost",
    },
    {
      id: "7",
      value: "vendor_po_raised",
      label: "Vendor Po Raised",
    },
    {
      id: "8",
      value: "dispatched",
      label: "Dispatched",
    },
    {
      id: "9",
      value: "delivered",
      label: "Delivered",
    },
  ];

  const columns = [
    {
      title: "BOQ Item",
      key: "boq_item",
      dataIndex: "boq_item",
      width: 200,
    },
    {
      title: "MRP",
      key: "mrp",
      dataIndex: "mrp",
      width: 100,
    },
    {
      title: "Category",
      key: "category_name",
      dataIndex: "category_name",
      width: 100,
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
      width: 50,
    },
    {
      title: "Unit",
      key: "unit",
      dataIndex: "unit",
      width: 60,
    },
    {
      title: "Brand",
      key: "brand",
      dataIndex: "brand",
      width: 130,
    },
    {
      title: "Landing Price",
      key: "unit_selling_price",
      width: 100,
      render: (data) => parseFloat(data["unit_selling_price"]).toFixed(2),
    },
    {
      title: "Selling Price",
      key: "unit_cost_price",
      width: 100,
      render: (data) => parseFloat(data["unit_cost_price"]).toFixed(2),
    },
    {
      title: "Margin",
      key: "margin",
      width: 100,
      render: (data) =>
        parseFloat(data.margin / (1 + data.margin / 100)).toFixed(2),
    },
    {
      title: "Tax",
      key: "tax",
      render: (data) => {
        var tax = Number(data?.tax_value);
        return (
          <>
            <div>{tax}%</div>
          </>
        );
      },
    },
    {
      title: "Tax Type",
      key: "tax_type",
      render: (data) => (
        <>
          {data?.tax_type == "igst" && "IGST"}
          {data?.tax_type == "cgst_sgst" && "CGST & SGST"}
          {data?.tax_type == "none" && "None"}
        </>
      ),
    },
    {
      title: "Amount",
      key: "amount",
      render: (data) => {
        return data["total_price"].toFixed(2);
      },
    },
  ];
  var totalAmount = 0;
  details?.po_items?.map((each) => {
    totalAmount += each?.total_price;
  });

  const downloadAsExcel = () => {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("Estimate");
    worksheet.columns = [
      { header: "BOQ Item", key: "boq_item" },
      { header: "Description", key: "item_description", width: 30 },
      { header: "Quantity", key: "quantity" },
      { header: "Unit", key: "unit" },
      { header: "Make/Brand", key: "brand", width: 20 },
      { header: "Cost Price", key: "unit_cost_price", width: 20 },
      { header: "Selling Price", key: "unit_selling_price", width: 15 },
      { header: "Margin", key: "margin" },
      { header: "Tax", key: "tax", width: 30 },
      { header: "Amount", key: "amount" },
    ];

    worksheet.addRows(
      details?.estimate_items.map((data) => {
        const totalPrice = data?.unit_selling_price * data?.quantity;
        const discount = data?.margin;
        const priceWGst = Number(totalPrice - discount);
        const tax = Number(data?.tax_value);

        return {
          ...data,
          tax: `${tax.toFixed(2)}%, Budget : ${Number(
            priceWGst * tax * 0.01
          ).toFixed(2)}`,
          amount: data["total_price"].toFixed(2),
        };
      })
    );
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Estimate.xlsx");
    });
  };

  const getTotalTaxableAmount = () => {
    let amount = 0;
    details?.estimate_items?.forEach((item) => {
      amount += parseFloat(
        parseFloat(item?.unit_cost_price, 2) * parseFloat(item?.quantity, 2)
      );
    });
    return amount;
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  useEffect(() => {
    if (assignedTo && details) {
      const userId = members?.find(
        (member) =>
          member?.user_organisation?.user?.name === details?.created_by
      )?.user_organisation?.user?.id;
      message.loading({
        content: "Assigning quote..",
        duration: 4,
        key: "assigning",
      });
      changeEstimateAssignee({
        estimate_id: estimateId,
        data: { assigned_to: assignedTo },
      });
    }
  }, [assignedTo]);

  return (
    <main
      style={{
        width: "100%",
        background: "#ffffff",
        padding: "1rem",
      }}
    >
      <PageHeader
        ghost={false}
        onBack={() => history("/app/project/estimates")}
        title="Pro Forma Invoice Details"
        backIcon={false}
        extra={[
          <>
            {revisionData?.length > 0 && (
              <Button
                onClick={() => {
                  setShowRevisions(!showRevisions);
                }}
              >
                See Revisions
              </Button>
            )}
          </>,
          <>
            <Space>
              <span>Assign to:</span>
              <Select
                style={{ width: 200 }}
                placeholder="Select a person"
                options={members.map((member) => ({
                  value: member?.user_organisation?.user?.id,
                  label: member?.user_organisation?.user?.name,
                }))}
                value={assignedTo}
                onChange={(value) => {
                  setAssignedTo(value);
                }}
              />
            </Space>
          </>,
          <>
            {poCreationAndEditGranted(props.settings?.user) && (
              <Dropdown
                overlay={
                  <Menu>
                    {/* <Menu.Item
                      key="1"
                      onClick={() => {
                        history(`/app/project/estimates/edit/` + details?.id, {
                          state: { editId: details?.id },
                        });
                      }}
                    >
                      Edit Pro Forma Invoice
                    </Menu.Item> */}
                    <Menu.Item
                      key="2"
                      onClick={() => {
                        window.open(EstimatePdfOpenApi + details?.id, "_blank");
                      }}
                    >
                      Download pdf
                    </Menu.Item>
                    {/* {!details?.isDraft && (
                      <Menu.Item
                        key="3"
                        onClick={() => {
                          setRowSelectionVisible(true);
                          const element =
                            document.getElementById("bill_to_div");
                          if (element) {
                            // 👇 Will scroll smoothly to the top of the next section
                            element.scrollIntoView({ behavior: "smooth" });
                          }
                          message.info(
                            "Select rows from pro forma invoice to make PO",
                            4
                          );
                        }}
                      >
                        Create PO
                      </Menu.Item>
                    )} */}
                    <Menu.Item
                      key="4"
                      onClick={() => {
                        createBudgetItemFromEstimate({
                          estimate_id: estimateId,
                          project_id: projectDetails?.id,
                        });
                      }}
                    >
                      Create Budget Items from this Pro Forma
                    </Menu.Item>
                    <Menu.Item
                      key="5"
                      onClick={() => {
                        resendEstimateMail(estimateId);
                      }}
                    >
                      Resend Pro Forma Mail
                    </Menu.Item>
                  </Menu>
                }
                key="1"
                className=""
              >
                <Button className="btn btn-primary text-white d-flex justify-content-center align-items-center">
                  Actions <ChevronDown />
                </Button>
                {/* PO Actions */}
              </Dropdown>
            )}
          </>,
        ]}
      ></PageHeader>
      {showRevisions && (
        <PageHeader ghost={false} className="mt-3">
          <Row gutter={16}>
            {revisionData?.map((revision, index) => {
              return (
                <Col
                  sm={6}
                  className="d-flex justify-content-center border p-2"
                >
                  <Col>
                    <Col>Created by: {revision?.revised_by__name}</Col>
                    <Col>
                      Created at: {getFormattedDate(revision?.modified_at)}
                    </Col>
                    <Col
                      style={{ width: "100%" }}
                      className="d-flex justify-content-space-between mt-1"
                    >
                      <Link
                        to={"/app/project/estimate-details/" + revision?.id}
                        target="_blank"
                      >
                        <Button>See Revision: {index + 1}</Button>
                      </Link>
                      {/* <Button
                        onClick={() => {
                          window.open(PowoPdfOpenApi + revision?.id, "_blank");
                        }}
                      >
                        See pdf
                      </Button> */}
                    </Col>
                  </Col>
                </Col>
              );
            })}
          </Row>
        </PageHeader>
      )}
      <img
        src={organisationDetails?.organisation_logo}
        style={{ height: "80px" }}
        className="mt-2"
      />
      <CardBody>
        {/* <div className="px-2">
          <Steps direction="horizontal" size="small" current={currentStep}>
            {track?.map((each, index) => (
              <Step
                key={index}
                title={each?.step}
                description={each?.description}
              />
            ))}
          </Steps>
        </div> */}
      </CardBody>
      <CardBody>
        <Row gutter={24}>
          <Col sm={12}>
            <CardBody>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Name
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{organisationDetails?.name}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Address
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.gst?.address}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  GST
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.gst?.gst_no}</Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Col>
          <Col sm={12}>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Created By
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>{details?.created_by}</Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Client
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>{" " + projectDetails?.project_name}</Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Lead ID
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>{details?.lead_id}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Quotation No.
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}> {details?.estimate_no}</Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Status
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>
                    {details?.estimate_status
                      ? statusOptions.find(
                          (e) => e.value == details?.estimate_status
                        )?.label
                      : "Draft"}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={16} className="mt-3">
              <Col sm={5} md={5}>
                Bank Details
              </Col>
              <Col sm={19} md={19}>
                <Row>
                  <Col sm={1}>:</Col>
                  <Col sm={22}>
                    Account Number (
                    {props?.settings?.branch?.bank_account_number})
                    <br />
                    IFSC Code ({props?.settings?.branch?.bank_ifsc})
                    <br />
                    UPI ({props?.settings?.branch?.branch_upi})
                    <br />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
      <Divider orientation="horizontal" />
      <Row gutter={24} className="mt-3" id="bill_to_div">
        {details?.bill_address && (
          <Col sm={11}>
            <CardBody>
              <div className="">
                <H6>Bill To</H6>
              </div>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Name
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.bill_address?.label}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Address
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.bill_address?.address}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Pincode
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.bill_address?.pincode}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Contact person
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.bill_address?.contact_person}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={5} md={5}>
                  Contact number
                </Col>
                <Col sm={19} md={19}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.bill_address?.contact_phone}</Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Col>
        )}
        {details?.ship_address && details?.bill_address && (
          <Col>
            <Divider type="vertical" style={{ height: "100%" }} />
          </Col>
        )}
        {details?.ship_address && (
          <Col sm={11}>
            <CardBody>
              <div className="">
                <H6>Ship To</H6>
              </div>
              <Row gutter={16}>
                <Col sm={6}>Name</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.ship_address?.label}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={6}>Address</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.ship_address?.address}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={6}>Pincode</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.ship_address?.pincode}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-2">
                <Col sm={6}>Contact person</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.ship_address?.contact_person}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col sm={6}>Contact number</Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>{details?.ship_address?.contact_phone}</Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={16} className="mt-1">
                <Col sm={6}>Selected address: </Col>
                <Col sm={18}>
                  <Row>
                    <Col sm={1}>:</Col>
                    <Col sm={11}>
                      {details?.ship_address?.address},{" "}
                      {details?.ship_address?.city}{" "}
                      {details?.ship_address?.pincode}
                    </Col>
                  </Row>
                </Col>
              </Row>
              {details?.ship_address?.google_map_address && (
                <Row gutter={16} className="mt-1">
                  <Col sm={6}>Google Map Address</Col>
                  <Col sm={18}>
                    <Row>
                      <Col sm={1}>:</Col>
                      <Col sm={11}>
                        <a
                          href={details?.ship_address?.google_map_address}
                          target="_blank"
                        >
                          {
                            details?.ship_address?.google_map_address?.length > 50
                              ? details?.ship_address?.google_map_address?.slice(0, 50) + "..."
                              : details?.ship_address?.google_map_address
                          }
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Col>
        )}
      </Row>
      <Divider orientation="horizontal" />
      <CardBody>
        <Table
          dataSource={details?.estimate_items}
          columns={columns}
          scroll={{ x: "max-content" }}
          pagination={false}
          rowKey={(record) => record?.id}
          rowSelection={
            rowSelectionVisible
              ? {
                  type: "checkbox",
                  ...rowSelection,
                }
              : false
          }
        />
      </CardBody>
      <Divider orientation="horizontal" />

      <Row>
        <Col sm={11}>
          <CardBody>
            <H6>Payment Terms</H6>
            <CardBody>
              {details?.estimate_payment_terms?.map((each, ind) => (
                <div key={ind}>
                  {each?.term}:{each?.percentage}%
                </div>
              ))}
            </CardBody>
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            <H6>Terms and Conditions</H6>
            <CardBody>
              <div className="mb-2">
                {details?.terms_and_condition?.description}
              </div>
            </CardBody>
          </CardBody>

          <CardBody>
            <div className="">
              <div>
                <span style={{ fontSize: "18px", fontWeight: "bolder" }}>
                  Documents
                </span>{" "}
                {"(Total files size should be less than 25MB)"}
              </div>
              {details?.documents?.map((document, index) => {
                return (
                  <Col style={{ padding: 8 }}>
                    <Col
                      style={{
                        border: "1px #D1D0CE solid",
                        padding: 4,
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                      onClick={() => {
                        openInNewTab(document?.file);
                      }}
                    >
                      {document?.file_name ??
                        document?.file?.replace(
                          "https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/media/porject_files/",
                          ""
                        )}
                    </Col>
                  </Col>
                );
              })}
              {details?.old_attachment !== "" &&
                JSON.parse(details?.old_attachment ?? "[]")?.map((document) => {
                  return (
                    <Col style={{ padding: 8 }}>
                      <Col
                        style={{
                          border: "1px #D1D0CE solid",
                          padding: 4,
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          const extension = document.split(".").pop();
                          handlePdfDownload(
                            document.replace(`.${extension}`, ""),
                            extension
                          );
                          // openInNewTab(
                          //   "https://mysite-powo-pdfs.s3.ap-south-1.amazonaws.com/" +
                          //     document
                          // );
                        }}
                      >
                        {document ?? ""}
                      </Col>
                    </Col>
                  );
                })}
            </div>
          </CardBody>
        </Col>
        <Col>
          <Divider type="vertical" style={{ height: "100%" }} />
        </Col>
        <Col sm={12}>
          <CardBody>
            <div className="d-flex justify-content-between">
              <div className="">Taxable Amount</div>
              <div className="">
                ₹ {Number(getTotalTaxableAmount()).toFixed(2)}
              </div>
            </div>
            <TaxAmount items={details?.estimate_items} />
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            {details?.estimate_additional_charges?.map((each, ind) => (
              <>
                <div className="d-flex justify-content-between" key={ind}>
                  <div className="">
                    {each?.charge_type}
                    {` (@${each?.tax_value + "%"} ${each?.tax_type})`}
                  </div>
                  <div className="">
                    {(
                      Number(each?.amount) +
                      Number(each?.amount) * Number(each?.tax_value) * 0.01
                    ).toFixed(2)}
                  </div>
                </div>
                {each.remark && each.remark != "" && (
                  <div>Remark: {each.remark}</div>
                )}
              </>
            ))}
          </CardBody>
          <Divider orientation="horizontal" />
          <CardBody>
            <div className="d-flex justify-content-between">
              <div className="">
                <H6>Total Amount</H6>
              </div>
              <div className="">
                {Number(details?.total_estimate_amount).toFixed(2)}(Rounded off)
              </div>
            </div>
          </CardBody>
        </Col>
      </Row>
      <Divider orientation="horizontal" />
    </main>
  );
};

const mapStateToProps = ({ dispatch, settings }) => {
  return {
    dispatch,
    settings,
  };
};

export default connect(mapStateToProps)(EstimateDetails);
